import { printLine, pause } from "../utilities.js";
import { state } from "../state.js";
import { screen } from "../screen.js";
import { getRandomColor, getRandomColorExcept } from "../colors.js";
import { Cell } from "../cell.js";

export const program = {
    name: "486",
    size: 69, // Number of lines of this 'program'
    list: async () => {
        await printLine("18 SYS 4112"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async () => {
        state.blockCursor = true;

        const DIGITS_486 = [
            "........................................",
            "........................................",
            "........................................",
            ".......##..........###..........#####...",
            "......###.........#####........######...",
            ".....####........##...##......##........",
            "....##.##.......##.....##....##.........",
            "...##..##......##.......##..##..........",
            "..##...##......##.......##..##..........",
            ".##....##......##.......##..##..........",
            ".##....##.......##.....##...##..........",
            ".##....##........##...##....##..........",
            ".############.....#####.....##.######...",
            ".############....#######....##########..",
            ".......##.......##.....##...##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##......##.......##..##.......##.",
            ".......##.......##.....##....##.....##..",
            ".......##........##...##......##...##...",
            ".......##.........#####........#####....",
            ".......##..........###..........###.....",
            "........................................",
            "........................................",
            "........................................"
        ];

        await screen.clearScreen();

        const fgColor = getRandomColor();
        for (let i = 0; i < DIGITS_486.length; i++) {
            let line = [];
            for (let j = 0; j < DIGITS_486[i].length; j++) {
                if (DIGITS_486[i][j] === "#") {
                    line.push(new Cell(" ", null, fgColor));
                } else {
                    const color = getRandomColorExcept(fgColor);
                    line.push(new Cell(" ", null, color));
                }
            }
            if (i === DIGITS_486.length - 1) {
                await printLine(line, { charDelay: 1, lineDelay: 1, endWithEnter: false, preventCursorShift: true });
            } else {
                await printLine(line, { charDelay: 1, lineDelay: 1, endWithEnter: false });
            }
        }

        setTimeout(() => {
          window.location.href = "https://486.dss-solutions.nl"; // Redirect to the 486 page  
        }, 5000);
        await pause(10000);
    }
};